import {Reducer} from "redux";
import {Action, ActionType} from "../../actions";
import {FormData} from "../../state/ShoppingDiagnostics/FormDataHistorical";

const updateFormData: Reducer<FormData> = (state: FormData = new FormData(), action: Action<ActionType, FormData>) => {
  switch (action.type) {
    case ActionType.SHOPPING_DIAGNOSTICS_HISTORICAL_CORRELATION_ID_UPDATED:
      return { ...state, ...action.data};
    case ActionType.SHOPPING_DIAGNOSTICS_FORM_IDENTITY_UPDATED_HISTORICAL:
      return { ...state, identity: action.data };
    case ActionType.SHOPPING_DIAGNOSTICS_HISTORICAL_DATA_VALIDATED:
      return {...state, historicalValidation: action.data}
    case ActionType.SHOPPING_DIAGNOSTICS_HISTORICAL_FORM_RESET:
      return new FormData();
    default:
      return state;
  }
};

export default updateFormData;
